module.exports = __webpack_public_path__ + "static/media/samatved.8684d7e3.jpg";